import React from "react";

import { useContextValue } from "./useContextValue";

export interface IHeaderContext {
  isNavOpen: boolean;
  openNav: VoidFunction;
  closeNav: VoidFunction;
}

const HeaderContext = React.createContext({} as IHeaderContext);

export const HeaderProvider: React.FC = (props) => {
  const value = useContextValue();

  return <HeaderContext.Provider value={value}>{props.children}</HeaderContext.Provider>;
};

export const useHeaderContext = () => {
  const context = React.useContext(HeaderContext);

  if (!context) {
    throw new Error("useHeaderContext must be inside HeaderProvider");
  }

  return context;
};
